/**
 * @fileoverview Molecule: what the illustration is currently offering.
 * @module components/molecules/DrawHint
 */

import { ProgressRing } from "@/components/atoms"
import { formatRemaining } from "@/lib/domain"
import type { Cooldown } from "@/types/types"

import "./DrawHint.css"

/** Props accepted by {@link DrawHint}. */
export interface DrawHintProps {
	/** Where the draw lock stands. */
	readonly cooldown: Cooldown
}

/**
 * The line under the illustration: an invitation, or a countdown.
 *
 * @description
 * A polite live region, not an assertive one: the countdown changes every
 * second and must never interrupt the phrase itself. Only the seconds are
 * re-read, because only the text node changes.
 *
 * @param props - The cooldown state.
 * @returns The rendered hint.
 */
export function DrawHint({ cooldown }: DrawHintProps) {
	if (cooldown.isReady) {
		return (
			<p className="draw-hint" aria-live="polite">
				Clique sur le dessin pour tirer une nouvelle phrase
			</p>
		)
	}

	return (
		<p className="draw-hint draw-hint--locked" aria-live="polite">
			<ProgressRing ratio={cooldown.ratio} />
			<span>
				Nouvelle phrase dans{" "}
				<strong className="draw-hint__clock">
					{formatRemaining(cooldown.remainingMs)}
				</strong>
			</span>
		</p>
	)
}
